export default __webpack_public_path__ + "static/media/home.3572010b.png";